export const popup = theme => ({
	wrapper: {
		position: "absolute",
		width: "242px",
		// height: "195px",
		backgroundColor: "#fff",
		border: "1px solid #F89470 ",
		zIndex: 99999
	},
	left: {
		color: "#fff",
		height: "100%"
	},
	top:{
		textAlign: "Left",
		fontWeight: 600,
		fontFamily: "Inter",
		fontSize: "14px",
		lineHeight: "17px",
		color: "#fff",
		width: "100%",
		margin: "5px",
		maxWidth: "Unset",
		flexBasis: "Unset"
	},
	center:{
		maxWidth: "Unset",
		flexBasis: "Unset"
	},
	bottom:{
		maxWidth: "Unset",
		flexBasis: "Unset",
		marginTop: "auto"
	},
	right: {
		padding: `0 ${theme.spacing.unit * 2}px`
	},
	lot: {
		display: "flex",
		alignItems: "center",
		alignContent: "center",
		textAlign: "center",
		height: "100%",
		justifyContent: "left"
	},
	value: {
		display: "flex",
		width: "100%",
		justifyContent: "left"
	},
	valueBold: {
		fontWeight: 700
	},
	valueDescription:{
		fontFamily: "Inter",
		fontWeight: 400,
		fontsize: "12px",
		lineHeight: "14.52px",
		color: "black"
	}

});
